import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RestService } from '@app/_services/rest.service';
import { from, Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import {AccountService, AlertService } from '@app/index';
import { MsalService } from '@azure/msal-angular';
import { catchError, concatMap, first } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { groups } from '@app/_services/auth-config';
import { AppComponent } from '@app/app.component';
import { ClaimDetails } from '@app/_models/claimDetails';
import { OriginalStatusTypes } from '@app/_models/originalStatusTypes';
import { UserActionsLogDatum } from '@app/_models/userActionsLogDatum';
import { Employee } from '@app/_models/employee.model';
import { Note } from '@app/_models/note';
import { MatRadioChange } from '@angular/material/radio';


@Component({
  selector: 'app-site-estimate',
  templateUrl: './site-estimate.component.html',
  styleUrls: ['./site-estimate.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SiteEstimateComponent implements OnInit {
  public form!: UntypedFormGroup;
  errorMsg!: string;
  refNo!: number;
  isSiteReservesEntered!:boolean;
  employeeId:number=0;
  isAssessorOrEstimator:boolean=false;
  claim!:ClaimDetails;
  lastNameS!: string;
  loading = false;
  submitted = false;
  result!: string;
  @Input() max: any;
  newNote!:Note;
  buildingMakeSafeRequired:boolean | null = null;
  restorationMakeSafeRequired:boolean | null = null;
  isChanged:boolean=false;

  validateInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    //const cursorPosition = inputElement.selectionStart || 0;
    let sanitizedValue = inputElement.value.replace(/[^0-9.]/g, '');
    const parts = sanitizedValue.split('.');
    if (parts.length > 2) {
      sanitizedValue = parts[0] + '.' + parts[1];
    }
    inputElement.value = sanitizedValue;
    //inputElement.setSelectionRange(cursorPosition, cursorPosition);
  }
  //isHMAUser!:boolean; 
  //isHMAClaim!:boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    private cdr: ChangeDetectorRef,
    public appComponent: AppComponent,
    private location: Location,
    private restService: RestService,
    private alertService: AlertService,
    private msalService: MsalService,
    private datePipe: DatePipe,
    private router: Router) {
    this.activatedRoute.params.subscribe(params => {
      this.refNo = params['refNo'];
      this.lastNameS = params['lastNameS'];
    });
    //this.form = new UntypedFormGroup({});
    this.getRemoteData();
  }

  ngOnInit(): void {
    this.alertService.clear();
    //this.getRemoteData();
    this.form = new UntypedFormGroup({
      siteReserveBldMakeSafe: new UntypedFormControl(null),
      siteReserveRstMakeSafe: new UntypedFormControl(null),// (this.claim.emergencyRepairEst === 0 && this.claim.makesafeRequiredRst? 0 : null)),
      siteReserveBuilding: new UntypedFormControl(null),//(this.claim.bldEstimate === 0 ? 0 : null)),//(cases.siteReserveBuilding !==null ? cases.siteReserveBuilding.toFixed(2) : (cases.bldEstimate !== null && cases.bldEstimate !== undefined? cases.bldEstimate.toFixed(2):'')),
      siteReserveRestoration: new UntypedFormControl(null),//(this.claim.restorationEstimate === 0 ? 0 : null)),//(cases.siteReserveRestoration !==null ? cases.siteReserveRestoration.toFixed(2) : (cases.restorationEstimate === null || cases.restorationEstimate  === undefined ? '' : cases.restorationEstimate .toFixed(2))),
      siteReserveContents: new UntypedFormControl(null),//(this.claim.ctsEstimate === 0 ? 0 : null)),//(cases.siteReserveContents !==null ? cases.siteReserveContents.toFixed(2) : (cases.ctsEstimate !== null && cases.ctsEstimate !== undefined? cases.ctsEstimate.toFixed(2):'')),
    });
    const email = this.msalService.instance.getActiveAccount()!.username!;
    this.restService.getUserDetailsByEmail(email).subscribe((x:Employee)=>{
      this.employeeId=x.employeeId; 
    });
    //this.cdr.detectChanges();
  }

  getRemoteData() {
    try {
      this.loading = true;
      this.isChanged=false;
      this.restService.getClaimDetailsForUpdate(this.refNo).subscribe((cases:ClaimDetails) => {
        if (cases){
          this.claim = cases;
          this.buildingMakeSafeRequired = cases.makesafeRequiredBld;
          this.restorationMakeSafeRequired = cases.makesafeRequiredRst;
          this.isSiteReservesEntered = !((cases.siteReserveBuilding === null || cases.siteReserveBuilding === 0) && (cases.siteReserveContents === null || cases.siteReserveContents ===  0) && (cases.siteReserveBldMakeSafe === null || cases.siteReserveBldMakeSafe === 0)  && (cases.siteReserveRstMakeSafe === null || cases.siteReserveRstMakeSafe === 0) && (cases.siteReserveRestoration === null || cases.siteReserveRestoration === 0));
          
          this.form.controls.siteReserveBldMakeSafe.setValue((this.claim && this.claim.emergencyRepairEst === 0) ? 0 : ((this.claim && this.claim.emergencyRepairEst=== null) ? null : (this.claim.makesafeRequiredBld ? this.claim.emergencyRepairEst?.toFixed(2): 0)));
          this.form.controls.siteReserveRstMakeSafe.setValue((this.claim && this.claim.emergencyRepairEst === 0) ? 0 : ((this.claim && this.claim.emergencyRepairEst=== null) ? null : (this.claim.makesafeRequiredRst ? this.claim.emergencyRepairEst?.toFixed(2) : 0)));
          this.form.controls.siteReserveBuilding.setValue((this.claim && this.claim.bldEstimate === 0) ? 0 : ((this.claim && this.claim.bldEstimate === null) ? null : this.claim.bldEstimate?.toFixed(2)));
          this.form.controls.siteReserveBuilding.updateValueAndValidity();
          this.form.controls.siteReserveRestoration.setValue((this.claim && this.claim.restorationEstimate === 0) ? 0 : ((this.claim && this.claim.restorationEstimate === null) ? null : this.claim.restorationEstimate?.toFixed(2)));
          this.form.controls.siteReserveRestoration.updateValueAndValidity();
          this.form.controls.siteReserveContents.setValue((this.claim && this.claim.ctsEstimate === 0) ? 0: ((this.claim && this.claim.ctsEstimate === null) ? null : this.claim.ctsEstimate?.toFixed(2)));
          this.form.controls.siteReserveContents.updateValueAndValidity();

          this.form.controls.siteReserveBldMakeSafe.valueChanges.subscribe((newValue) => {
            this.isChanged=true;
          });
          this.form.controls.siteReserveRstMakeSafe.valueChanges.subscribe((newValue) => {
            this.isChanged=true;
          });this.form.controls.siteReserveBuilding.valueChanges.subscribe((newValue) => {
            this.isChanged=true;
          });this.form.controls.siteReserveRestoration.valueChanges.subscribe((newValue) => {
            this.isChanged=true;
          });this.form.controls.siteReserveContents.valueChanges.subscribe((newValue) => {
            this.isChanged=true;
          });

          this.loading = false;
        }
      },
      error => {
        this.loading = false;
        return false;
      }
      );
      return true;
    }
    catch (error: any) {
      this.alertService.error(error);
      return false;
    }
  }

  public onCancel = () => {
    this.location.back();
  }

public updateClaim= (formValue: any) => {
  if (this.form.valid) {
    const isBldMakeSafeEmpty = this.buildingMakeSafeRequired && this.form.controls.siteReserveBldMakeSafe.value === null;
    const isRstMakeSafeEmpty = this.restorationMakeSafeRequired && this.form.controls.siteReserveRstMakeSafe.value === null;
    if (this.form.controls.siteReserveBuilding.value === null && this.form.controls.siteReserveRestoration.value === null && this.form.controls.siteReserveContents.value === null && isBldMakeSafeEmpty && isRstMakeSafeEmpty) {
      Swal.fire({
        title: '<strong>All Site Reserve Estimates are empty!</strong><br/><br/>Please enter estimates amount before update!', 
        icon: 'warning',
        showDenyButton: false,
        confirmButtonText: `OK`,
        confirmButtonColor: '#007bff',
        width: 450,
        padding: '1em',
        heightAuto: false,
      }).then((result) => {
        if (result.isConfirmed) {
          return;
        }
      });
    }
    else if (isBldMakeSafeEmpty || isRstMakeSafeEmpty){
      const bldMakeSafeEmptyStr = 'You marked Building Make Safe required, but have not entered any estimate.';
      const rstMakeSafeEmptyStr = 'You marked Restoration Make Safe required, but have not entered any estimate.';
      Swal.fire({
        title: '<strong>Site Reserve Make Safe Estimate(s) empty!</strong><br/>'+ (isBldMakeSafeEmpty ? bldMakeSafeEmptyStr : '') 
                + (isRstMakeSafeEmpty ? '<br/>'+rstMakeSafeEmptyStr : '') + '<br/>Please enter estimate amount before update!',
        icon: 'warning',
        showDenyButton: false,
        confirmButtonText: `OK`,
        confirmButtonColor: '#007bff',
        width: 450,
        padding: '1em',
        heightAuto: false,
      }).then((result) => {
        if (result.isConfirmed) {
          return;
        }
      });
    }
    else if ((this.claim.emergencyRepairEst === 0 && ((this.buildingMakeSafeRequired && Number(this.form.controls.siteReserveBldMakeSafe.value) > 0) || (this.restorationMakeSafeRequired && Number(this.form.controls.siteReserveRstMakeSafe.value) > 0)))
             || (this.claim.bldEstimate ===0 && Number(this.form.controls.siteReserveBuilding.value) >0 )
             || (this.claim.restorationEstimate ===0 && Number(this.form.controls.siteReserveRestoration.value) >0 )
             || (this.claim.ctsEstimate ===0 && Number(this.form.controls.siteReserveContents.value) >0 )){
      let msg:string[]=[];
      if (this.claim.emergencyRepairEst === 0 && ((this.buildingMakeSafeRequired && Number(this.form.controls.siteReserveBldMakeSafe.value) > 0) || (this.restorationMakeSafeRequired && Number(this.form.controls.siteReserveRstMakeSafe.value) > 0))){
        msg.push('You are going to update the Emergency Repair Estimate to '+ (Number(this.form.controls.siteReserveBldMakeSafe.value)+Number(this.form.controls.siteReserveRstMakeSafe.value)) + ' againt the current amount of 0');
      }
      if (this.claim.bldEstimate === 0 && Number(this.form.controls.siteReserveBuilding.value)>0){
        msg.push('You are going to update the Building Estimate to '+ this.form.controls.siteReserveBuilding.value + ' againt the current amount of 0');
      }
      if (this.claim.restorationEstimate === 0 && Number(this.form.controls.siteReserveRestoration.value)>0){
        msg.push('You are going to update the restoration Estimate to '+ this.form.controls.siteReserveRestoration.value + ' againt the current amount of 0');
       }
      if (this.claim.ctsEstimate === 0 && Number(this.form.controls.siteReserveContents.value)>0){
        msg.push('You are going to update the Contents Estimate to '+ this.form.controls.siteReserveContents.value + ' againt the current amount of 0');
      }
  
      Swal.fire({
        title:'<strong>The current Estimate(s) already entered as $0!</strong><br/><br/>'+ msg.join('. \n')+'<br/><br/>Click Yes to update, or click No to have a check before to update.',
        icon: 'question',
        showDenyButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
        confirmButtonColor: '#007bff',
        denyButtonColor: '#dc3545',
        focusDeny: true,
        width: 450,
        padding: '1em',
        heightAuto: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateData();
        }
      });
    }
    else{
      Swal.fire({
        title: 'Are you sure you want to update the Site Reserve Estimates?',
        icon: 'question',
        showDenyButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
        confirmButtonColor: '#007bff',
        denyButtonColor: '#dc3545',
        focusDeny: true,
        width: 450,
        padding: '1em',
        heightAuto: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.alertService.clear();
          this.updateData();
        }
      });
    }
  }
}

updateData(){
  type Param = {
    op: string;
    path: string;
    value: number | boolean | null;
  };
  let body: Param[] = [ 
    { "op": "replace", "path": "/refNo", "value": this.refNo},
  ];
  let noteStr:string[] = [];
  if (this.buildingMakeSafeRequired && this.form.controls.siteReserveBldMakeSafe.value){
    body.push({ "op": "replace", "path": "/siteReserveBldMakeSafe", "value": Number(this.form.controls.siteReserveBldMakeSafe.value) });
    noteStr.push('Site Reserve Building Make Safe updated to $' + this.form.controls.siteReserveBldMakeSafe.value);
    if (!this.claim.makesafeRequiredBld){
      body.push({ "op": "replace", "path": "/makesafeRequiredBld", "value": true });
      noteStr.push('Building Make Safe Required updated from False to True');
    }
  }

  if (!this.buildingMakeSafeRequired && this.claim.makesafeRequiredBld){
    body.push({ "op": "replace", "path": "/makesafeRequiredBld", "value": false });
    noteStr.push('Building Make Safe Required updated from True to False');
    if (this.claim.makesafeStartedDateBld){
      body.push({ "op": "replace", "path": "/makesafeStartedDateBld", "value": null });
      noteStr.push('Building Make Safe Started Date updated from '+ this.datePipe.transform(this.claim.makesafeStartedDateBld, 'yyyy-MM-dd')?.toString()! + ' to null');
    }
    if (this.claim.makesafeCompletedDateBld){
      body.push({ "op": "replace", "path": "/makesafeCompletedDateBld", "value": null });
      noteStr.push('Building Make Safe Completed Date updated from '+ this.datePipe.transform(this.claim.makesafeCompletedDateBld, 'yyyy-MM-dd')?.toString()! + ' to null');
    }
  }

  if (this.restorationMakeSafeRequired && this.form.controls.siteReserveRstMakeSafe.value){
    body.push({ "op": "replace", "path": "/siteReserveRstMakeSafe", "value": Number(this.form.controls.siteReserveRstMakeSafe.value) });
    noteStr.push('Site Reserve Restoration Make Safe updated to $' + this.form.controls.siteReserveRstMakeSafe.value);// +((Number(this.form.controls.siteReserveMakeSafe.value)!==0) ? '. And Emergency Repair Estimate updated from '+ this.claim.siteReserveBldMakeSafe+ ' to $'+this.form.controls.siteReserveBldMakeSafe.value : ''));
    if (!this.claim.makesafeRequiredRst){
      body.push({ "op": "replace", "path": "/makesafeRequiredRst", "value": true });
      noteStr.push('Restoration Make Safe Required updated from False to True');
    }
  }

  if (!this.restorationMakeSafeRequired && this.claim.makesafeRequiredRst){
    body.push({ "op": "replace", "path": "/makesafeRequiredRst", "value": false });
    noteStr.push('Restoration Make Safe Required updated from True to False');
    if (this.claim.makesafeStartedDateRst){
      body.push({ "op": "replace", "path": "/makesafeStartedDateRst", "value": null });
      noteStr.push('Restoration Make Safe Started Date updated from '+ this.datePipe.transform(this.claim.makesafeStartedDateRst, 'yyyy-MM-dd')?.toString()! + ' to null');
    }
    if (this.claim.makesafeCompletedDateRst){
      body.push({ "op": "replace", "path": "/makesafeCompletedDateRst", "value": null });
      noteStr.push('Restoration Make Safe Completed Date updated from '+ this.datePipe.transform(this.claim.makesafeCompletedDateRst, 'yyyy-MM-dd')?.toString()! + ' to null');
    }
  }

  if (Number(this.form.controls.siteReserveBldMakeSafe.value)!==0 || Number(this.form.controls.siteReserveRstMakeSafe.value)!==0){
    body.push({ "op": "replace", "path": "/emergencyRepairEst", "value": (this.buildingMakeSafeRequired ? Number(this.form.controls.siteReserveBldMakeSafe.value) : 0) + (this.restorationMakeSafeRequired ? Number(this.form.controls.siteReserveRstMakeSafe.value) : 0)});
    noteStr.push('Emergency Repair Estimate updated from '+ this.claim.emergencyRepairEst + ' to '+((this.buildingMakeSafeRequired ? Number(this.form.controls.siteReserveBldMakeSafe.value) : 0) + (this.restorationMakeSafeRequired ? Number(this.form.controls.siteReserveRstMakeSafe.value) : 0)));
  }
  
  if (this.form.controls.siteReserveRestoration.value !== null){
    body.push({ "op": "replace", "path": "/siteReserveRestoration", "value": Number(this.form.controls.siteReserveRestoration.value) });
    if (Number(this.form.controls.siteReserveRestoration.value)!==0){
      body.push({ "op": "replace", "path": "/restorationEstimate", "value": Number(this.form.controls.siteReserveRestoration.value) });
    }
    noteStr.push('Site Reserve Restoration updated to $' + this.form.controls.siteReserveRestoration.value +((Number(this.form.controls.siteReserveRestoration.value)!==0) ? '. \nAnd Restoration Estimate updated from '+ this.claim.siteReserveRestoration+ ' to $'+this.form.controls.siteReserveRestoration.value : ''));
  }

  if (this.form.controls.siteReserveBuilding.value !== null){
    body.push({ "op": "replace", "path": "/siteReserveBuilding", "value": Number(this.form.controls.siteReserveBuilding.value) });
    if (Number(this.form.controls.siteReserveBuilding.value)!==0){
      body.push({ "op": "replace", "path": "/bldEstimate", "value": Number(this.form.controls.siteReserveBuilding.value) });
    }
    noteStr.push('Site Reserve Building updated to $' + this.form.controls.siteReserveBuilding.value +((Number(this.form.controls.siteReserveBuilding.value)!==0) ? '. \nAnd Building Estimate updated from '+ this.claim.siteReserveBuilding+ ' to $'+this.form.controls.siteReserveBuilding.value : ''));
  }

  if (this.form.controls.siteReserveContents.value !== null){
    body.push({ "op": "replace", "path": "/siteReserveContents", "value": Number(this.form.controls.siteReserveContents.value) });
    if (Number(this.form.controls.siteReserveContents.value)!==0){
      body.push({ "op": "replace", "path": "/ctsEstimate", "value": Number(this.form.controls.siteReserveContents.value) });
    }
    noteStr.push('Site Reserve Contents updated to $' + this.form.controls.siteReserveContents.value +((Number(this.form.controls.siteReserveContents.value)!==0) ? '. \nAnd Contents Estimate updated from '+ this.claim.siteReserveContents+ ' to $'+this.form.controls.siteReserveContents.value : ''));
  }

  const userFullName = this.msalService.instance.getActiveAccount()!.name!;
  this.newNote = {
    refNo: this.refNo,
    date: this.datePipe.transform(new Date(), 'yyyy-MM-dd')?.toString()!,
    addedBy: userFullName,
    initiatedBy: "Mk3 Staff",
    noteTypeId: 4,
    subTypeId: 6,
    reasonId: 3,
    //notes: userFullName + ' changed claim original status from \'At Quote\' to \'Quote Submitted\' after  estimator  has  entered '+ this.datePipe.transform(this.form.controls.quoteSubmittedDate.value, 'yyyy-MM-dd')?.toString()!,
    notes: userFullName + ' has updated the Site Reserve Estimates at '+ this.datePipe.transform(new Date(), 'HH:mm yyyy-MM-dd')?.toString()! 
      +' for -\n'+ noteStr.join('. \n'),
    private: 0,//-1 = Private, 0 = Public
    timeStamp: null,
    followUpDate: null,
    followUpUser: null,
    followUpComplete: null,
    clientId: this.claim.clientId,//null,
    isExternalAssessorVisible:false,
    addedById:this.employeeId,
    claimNoteInitiatedById:1,
    isNotifyTeam:false,
  };
  
  let successMessageShown = false;
  let errorMessageShown = false;
  this.restService.updateClaimDetails(this.refNo, body)
    .pipe(
      first(),
      concatMap(() => this.restService.addNewNote(this.newNote).pipe(first())),
      // concatMap(() => from(this.generateActionsList()).pipe(
      //   concatMap((actionLogs) => from(actionLogs).pipe(
      //     concatMap((actionLog) => this.restService.addUserActionsLogDatum(actionLog))
      //   ))
      // )),
      catchError((error) => {
        if (!errorMessageShown) {
          if (error.error instanceof ErrorEvent) {
            this.errorMsg = `Error: ${error.error.message}`;
          } else {
            this.errorMsg = error;
          }
          this.alertService.clear();
          this.alertService.error(this.errorMsg);
          Swal.fire('Site Reserve Estimate(s) updated, but failed to add new note for the update! Please contact IT Desktop for support if you find your update not successful!', '', 'error');
          errorMessageShown = true;
        }
        return throwError(this.errorMsg);
      })
    )
    .subscribe({
      next: () => {
        if (!successMessageShown) {
          Swal.fire('Site Reserve Estimate(s) updated successfully, and new note has been added successfully!', '', 'success');
          successMessageShown = true;
          this.router.navigate(['../case-details/' + this.claim.refNo]).then(() => {});
        }
      }
    });
  }

  radioChange(event: any, index:number=-1){
    this.isChanged=true;
    if (index === 1) {
      this.buildingMakeSafeRequired = event.target.type === 'checkbox' ? event.target.checked : event.target.value;//event.value;
      this.form.controls.buildingMakeSafeRequiredOptions.setValue(event.value);
      this.form.controls.buildingMakeSafeRequiredOptions.updateValueAndValidity();
    }
    else {
      this.restorationMakeSafeRequired=event.target.type === 'checkbox' ? event.target.checked : event.target.value;//event.value;
      this.form.controls.restorationMakeSafeRequiredOptions.setValue(event.value);
      this.form.controls.restorationMakeSafeRequiredOptions.updateValueAndValidity();
    }
    this.cdr.detectChanges();
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.form.controls[controlName].hasError(errorName);
  }
}